query SupportRequestsOpenCount {
  supportRequestsOpenCount
}
